import { Header, Footer } from "components";
import { useSEO } from "hooks";
/**
 * A Layout component
 */
export default function Layout({
  children,
  headerLinks,
  footerLinks,
  page,
  transparentHeader = false,
  lightLogo = false,
  footerOverlay = false,
}) {
  const SEO = useSEO({ page });
  return (
    <>
      <Header
        links={headerLinks}
        transparent={transparentHeader}
        lightLogo={lightLogo}
      ></Header>
      {SEO}
      <main style={footerOverlay ? undefined : { contain: "paint" }}>{children}</main>
      <Footer links={footerLinks} overlay={footerOverlay}></Footer>
    </>
  );
}
